import React from "react";
import "./product.css"; // Import the new CSS file
import "./services.css";
import { useNavigate } from "react-router-dom";

export const Services = () => {
  const navigate = useNavigate(); // Hook for navigation

  const handleCalculateClick = (productCode) => {
    navigate(`/cost-${productCode}`); // Navigate to dynamic path
  };

  return (
    <div id="services" className="sv_services">
      <div className="container">
        <div className="sv_section-title">
          <h2>Our Products</h2>
        </div>
        <div className="sv_row">
          {/* Static Product Cards */}
          <div className="sv_product-card">
            <img
              src="productImg/Plasticrawmaterial.jpeg"
              alt="Plastics Raw Materials"
              className="sv_product-icon"
            />
            <div className="sv_product-desc">
              <h3>Plastics Raw Materials</h3>
              <p>High-quality raw materials for all your plastic needs.</p>
              <button
                className="btn btn-primary sv_gradient-btn"
                onClick={() => handleCalculateClick("PRM")} // Pass the product code dynamically
              >
                Calculate
              </button>
            </div>
          </div>

          <div className="sv_product-card">
            <img
              src="productImg/strapingroll.jpg"
              alt="Plastics Raw Materials"
              className="sv_product-icon"
            />
            <div className="sv_product-desc">
              <h3>Strapping Role</h3>
              <p>Durable strapping rolls for secure packaging.</p>
              <button
                className="btn btn-primary sv_gradient-btn"
                onClick={() => handleCalculateClick("SR")}
              >
                Calculate
              </button>
            </div>
          </div>

          <div className="sv_product-card">
            <img
              src="productImg/corrugated box.jpg"
              alt="Plastics Raw Materials"
              className="sv_product-icon"
            />
            <div className="sv_product-desc">
              <h3>Corrugated Box</h3>
              <p>Strong corrugated boxes for safe transport.</p>
              <button
                className="btn btn-primary sv_gradient-btn"
                onClick={() => handleCalculateClick("CB")}
              >
                Calculate
              </button>
            </div>
          </div>

          <div className="sv_product-card">
            <img
              src="productImg/hdpefabric.jpg"
              alt="Plastics Raw Materials"
              className="sv_product-icon"
            />
            <div className="sv_product-desc">
              <h3>HDPE Fabrics</h3>
              <p>Versatile HDPE fabrics for multiple applications.</p>
              <button
                className="btn btn-primary sv_gradient-btn"
                onClick={() => handleCalculateClick("HF")}
              >
                Calculate
              </button>
            </div>
          </div>

          <div className="sv_product-card">
            <img
              src="productImg/bopptape.jpeg"
              alt="Plastics Raw Materials"
              className="sv_product-icon"
            />
            <div className="sv_product-desc">
              <h3>BOPP Gum Tape</h3>
              <p>Strong adhesive tapes for effective sealing.</p>
              <button
                className="btn btn-primary sv_gradient-btn"
                onClick={() => handleCalculateClick("BGT")}
              >
                Calculate
              </button>
            </div>
          </div>

          <div className="sv_product-card">
            <img
              src="productImg/papertube.jpg"
              alt="Plastics Raw Materials"
              className="sv_product-icon"
            />
            <div className="sv_product-desc">
              <h3>Core Paper Tube</h3>
              <p>Durable core tube paper tubes for packaging needs.</p>
              <button
                className="btn btn-primary sv_gradient-btn"
                onClick={() => handleCalculateClick("TPT")}
              >
                Calculate
              </button>
            </div>
          </div>

          <div className="sv_product-card">
            <img
              src="productImg/hmldbag.jpg"
              alt="Plastics Raw Materials"
              className="sv_product-icon"
            />
            <div className="sv_product-desc">
              <h3>HM LD Bag</h3>
              <p>High-quality HM LD bags for secure packaging.</p>
              <button
                className="btn btn-primary sv_gradient-btn"
                onClick={() => handleCalculateClick("HLB")}
              >
                Calculate
              </button>
            </div>
          </div>

          <div className="sv_product-card">
            <img
              src="productImg/thermocol.jpg"
              alt="Plastics Raw Materials"
              className="sv_product-icon"
            />
            <div className="sv_product-desc">
              <h3>Thermacoal Sheet</h3>
              <p>Protective thermacoal sheets for cushioning and insulation.</p>
              <button
                className="btn btn-primary sv_gradient-btn"
                onClick={() => handleCalculateClick("TS")}
              >
                Calculate
              </button>
            </div>
          </div>

          <div className="sv_product-card">
            <img
              src="productImg/strechwrp.jpg"
              alt="Plastics Raw Materials"
              className="sv_product-icon"
            />
            <div className="sv_product-desc">
              <h3>Stretch Wrap Film</h3>
              <p>High-quality stretch wrap film for secure wrapping.</p>
              <button
                className="btn btn-primary sv_gradient-btn"
                onClick={() => handleCalculateClick("SWF")}
              >
                Calculate
              </button>
            </div>
          </div>

          <div className="sv_product-card">
            <img
              src="productImg/epfsheet.jpg"
              alt="Plastics Raw Materials"
              className="sv_product-icon"
            />
            <div className="sv_product-desc">
              <h3>EPE Foam Sheet</h3>
              <p>Lightweight and protective EPE foam sheets for packaging.</p>
              <button
                className="btn btn-primary sv_gradient-btn"
                onClick={() => handleCalculateClick("EFS")}
              >
                Calculate
              </button>
            </div>
          </div>

          <div className="sv_product-card">
            <img
              src="productImg/bubble.jpg"
              alt="Plastics Raw Materials"
              className="sv_product-icon"
            />
            <div className="sv_product-desc">
              <h3>Bubble Sheet</h3>
              <p>
                Bubble sheets for safe and secure packaging of fragile items.
              </p>
              <button
                className="btn btn-primary sv_gradient-btn"
                onClick={() => handleCalculateClick("BS")}
              >
                Calculate
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
